var BrowserFS = require('browserfs');module.exports=BrowserFS.BFSRequire('fs');



/*****************
 ** WEBPACK FOOTER
 ** ./shims/fs.js
 ** module id = 27
 ** module chunks = 0
 **/